var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.007 0H0.993C0.44475 0 0 0.44475 0 0.993V17.007C0 17.556 0.44475 18 0.993 18H9.6135V11.0295H7.26675V8.31375H9.6135V6.3075C9.6135 3.98325 11.034 2.71875 13.1077 2.71875C14.1015 2.71875 14.9558 2.7915 15.2048 2.8245V5.2545H13.764C12.639 5.2545 12.42 5.79525 12.42 6.58275V8.316H15.108L14.7593 11.0385H12.42V18H17.0062C17.556 18 18 17.556 18 17.007V0.993C18 0.44475 17.556 0 17.007 0Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9c8a8364.svg";
export { ForwardRef as ReactComponent };